var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-main',{staticClass:"info-wrap"},[_c('div',{staticClass:"info-box"},[_c('div',[_c('div',{staticClass:"info-head tc"},[_c('h3',[_vm._v("社区 - 行业交流与信息枢纽")])]),_c('div',{staticClass:"info-content",domProps:{"innerHTML":_vm._s(_vm.infoText)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }